export default __webpack_public_path__ + "static/media/img-53.ce7d3748.jpg";